var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-assignation",class:[
		_vm.isFlyout
			? 'customer-assignation--manage-customers'
			: 'customer-assignation--pre-assign-customers'
	]},[_c('div',{staticClass:"customer-assignation__search"},[_c('Search',{attrs:{"variant":"toggle-icons","placeholder":"Search Clients"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('ul',{staticClass:"customer-assignation__list"},_vm._l((_vm.customers),function(customer){return _c('li',{key:customer.value,class:[
				_vm.isFlyout
					? 'customer-assignation__list-item' +
					  [customer.modelValue ? ' is-checked' : '']
					: 'customer-assignation__list-item'
			]},[_c('CustomerAssignationItem',{attrs:{"customer":customer,"isFlyout":_vm.isFlyout},on:{"change":_vm.updateCustomer}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }